import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  addCommas,
  base64ToBlob,
  cleanSpecialNaming,
  decodeBcNaming,
  convertFileToBase64,
  isInvalidDate,
  mapBcAttachmentFileType,
  parseApiError,
} from "../HelperFx/common";
import { Row, Col } from "reactstrap";
import {
  documentAttachment,
  documentAttachments,
  companyDefault,
  base64backendtoken,
} from "../HelperFx/datalinks.js";
import axios from "axios";
import "./standardCard.css";

const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;

const StandardPageMain = ({
  title,
  initialData = {},
  fields,
  actions = [],
  onChange: pageOnChange,
  onBlur: pageOnBlur,
  tableId = 0,
  redirectTo,
  PreventEdit = false,
  authToken,
  attachmentApi,
  onAttachmentError,
}) => {
  const fileInputRef = useRef(null);
  const [formData, setFormData] = useState(initialData);
  const [attachments, setAttachments] = useState([]);
  const [newSelectedFile, setNewSelectedFile] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const [isAttaching, setIsAttaching] = useState(false);

  const navigate = useNavigate();
  const documentNo = initialData.documentNo || initialData.no || "";
  const attachmentEndpoint =
    attachmentApi ||
    (REACT_DATA_URL ? `${REACT_DATA_URL}${documentAttachments}` : documentAttachment);
  const attachmentToken =
    authToken ||
    (REACT_UNAME && REACT_PWD
      ? btoa(`${REACT_UNAME}:${REACT_PWD}`)
      : base64backendtoken);
  const canAttach =
    tableId !== 0 &&
    !PreventEdit &&
    (!initialData.status || initialData.status === "Open");

  useEffect(() => {
    setFormData(initialData);
  }, [initialData]);

  useEffect(() => {
    if (documentNo && tableId !== 0) {
      getDocumentAttachments(documentNo);
    }
  }, [documentNo, tableId]);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    if (typeof pageOnChange === "function") {
      pageOnChange(field, value, formData);
    }
  };

  console.log("Now here" + initialData.documentNo);

  const handleBlur = (field, value) => {
    // if (initialData[field] === value) return;
    // if (value === undefined || value === null) return;
    if (value !== true && value !== false) {
      if (initialData[field] === value) return;
    }
    // console.log(value);
    // }
    if (value === undefined || value === null) return;

    if (typeof pageOnBlur === "function") {
      pageOnBlur(field, value, formData);
      setFormData(formData);
    }
  };

  const handleFileUpload = (e, fieldName) => {
    const files = Array.from(e.target.files);
    if (fieldName) {
      setFormData({ ...formData, [fieldName]: files });
    } else {
      setAttachments([...attachments, ...files]);
    }
  };

  const renderField = (field) => {
    const raw = formData[field.name];
    const locked = PreventEdit || field.disabled;
    const value =
      field.format === "amount"
        ? addCommas(raw)
        : typeof raw === "string"
          ? locked
            ? cleanSpecialNaming(raw)
            : decodeBcNaming(raw)
          : raw ?? "";

    switch (field.type) {
      case "textarea":
        return (
          <textarea
            value={value}
            onChange={(e) => handleChange(field.name, e.target.value)}
            onBlur={(e) => handleBlur(field.name, e.target.value)}
            style={styles.input}
            disabled={PreventEdit || field.disabled}
          />
        );
      case "decimal":
        if (field.format === "amount") {
          return (
            <input
              type="text"
              value={value ?? ""}
              style={styles.input}
              disabled
              readOnly
            />
          );
        }
        return (
          <input
            type="number"
            value={value ?? ""}
            step="any"
            onChange={(e) => {
              const val = e.target.value;
              handleChange(field.name, val === "" ? null : val.toString());
            }}
            onBlur={(e) => {
              const val = e.target.value;
              handleBlur(field.name, val === "" ? null : val.toString());
            }}
            style={styles.input}
            disabled={PreventEdit || field.disabled}
          />
        );
      case "integer":
        return (
          <input
            type="number"
            value={value}
            onChange={(e) => {
              const intValue =
                e.target.value === "" ? 0 : parseInt(e.target.value, 10) || "";
              handleChange(field.name, intValue);
            }}
            onBlur={(e) => {
              const intValue =
                e.target.value === "" ? 0 : parseInt(e.target.value, 10) || "";
              handleBlur(field.name, intValue);
            }}
            style={styles.input}
            disabled={PreventEdit || field.disabled}
          />
        );
      case "select":
        return (
          <select
            value={value}
            onChange={(e) => handleChange(field.name, e.target.value)}
            style={styles.input}
            onBlur={(e) => handleBlur(field.name, e.target.value)}
            disabled={PreventEdit || field.disabled}
          >
            <option value=""></option>
            {field.options?.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        );
      case "checkbox":
        return (
          <input
            type="checkbox"
            checked={value}
            onChange={(e) => handleChange(field.name, e.target.checked)}
            onBlur={(e) => handleBlur(field.name, e.target.checked)}
            disabled={PreventEdit || field.disabled}
          />
        );
      case "datetime":
        return (
          <input
            type="datetime-local"
            value={value}
            onChange={(e) => handleChange(field.name, e.target.value)}
            style={styles.input}
            disabled={PreventEdit || field.disabled}
            onBlur={(e) => handleBlur(field.name, e.target.value)}
          />
        );
      case "radio":
        return (
          <div style={{ display: "flex", gap: "12px" }}>
            {field.options?.map((opt, i) => (
              <label key={i}>
                <input
                  type="radio"
                  name={field.name}
                  value={opt.value}
                  checked={value === opt.value}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  disabled={PreventEdit || field.disabled}
                  onBlur={(e) => handleBlur(field.name, e.target.value)}
                />
                {opt.label}
              </label>
            ))}
          </div>
        );
      case "file":
        return (
          <input
            type="file"
            multiple={field.multiple}
            onChange={(e) => handleFileUpload(e, field.name)}
            disabled={PreventEdit || field.disabled}
          />
        );
      case "date": {
        const safeDate = !value || isInvalidDate(value) ? "" : value;
        return (
          <input
            type="date"
            value={safeDate}
            onChange={(e) => handleChange(field.name, e.target.value)}
            style={styles.input}
            disabled={PreventEdit || field.disabled}
            onBlur={(e) => handleBlur(field.name, e.target.value)}
            onFocus={(e) => {
              // If empty, set to today on focus
              if (!e.target.value || isInvalidDate(e.target.value)) {
                const today = new Date();
                const todayStr = today.toISOString().split("T")[0];
                handleChange(field.name, todayStr);
              }
            }}
          />
        );
      }

      default:
        return (
          <input
            type={field.type || "text"}
            value={value}
            onChange={(e) => handleChange(field.name, e.target.value)}
            onBlur={(e) => handleBlur(field.name, e.target.value)}
            style={styles.input}
            disabled={PreventEdit || field.disabled}
          />
        );
    }
  };

  const reportAttachmentError = (error, fallback) => {
    if (typeof onAttachmentError === "function") {
      onAttachmentError(parseApiError(error) || fallback);
    }
  };

  const removeAttachment = (systemId, docNo) => {
    axios
      .delete(`${attachmentEndpoint}(${systemId})?${companyDefault}`, {
        headers: {
          Authorization: `Basic ${attachmentToken}`,
        },
      })
      .then(() => getDocumentAttachments(docNo || documentNo))
      .catch((error) => reportAttachmentError(error, "Failed to remove the attachment."));
  };

  const makeAttachment = async (file, docNo, documentType) => {
    if (!file || tableId === 0 || !docNo || isAttaching) {
      return;
    }

    setIsAttaching(true);
    try {
      const fileContent = await convertFileToBase64(file);
      const extension = String(file.name || "").split(".").pop() || "";
      const body = {
        FileName: file.name,
        fileType: mapBcAttachmentFileType(file.name, file.type),
        FileExtension: extension,
        FileContentBase64: fileContent.split(",")[1],
        TableID: tableId,
        No: docNo,
        documentType: documentType || "Quote",
      };
      await axios.post(`${attachmentEndpoint}?${companyDefault}`, body, {
        headers: { Authorization: `Basic ${attachmentToken}` },
      });
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setNewSelectedFile([]);
      await getDocumentAttachments(docNo);
    } catch (error) {
      reportAttachmentError(error, "Failed to attach the file.");
    } finally {
      setIsAttaching(false);
    }
  };

  const getDocumentAttachments = async (docNo) => {
    setNewSelectedFile([]);

    try {
      const response = await axios.get(
        `${attachmentEndpoint}?${companyDefault}&$filter=No eq '${docNo}' and TableID eq ${tableId}`,
        {
          headers: { Authorization: `Basic ${attachmentToken}` },
        },
      );
      setSelectedFile(response.data.value || []);
      setNewSelectedFile([]);
    } catch (error) {
      reportAttachmentError(error, "Failed to load attachments.");
    }
  };

  const downloadAttachment = async (systemId) => {
    try {
      const response = await axios.get(
        `${attachmentEndpoint}(${systemId})?${companyDefault}`,
        {
          headers: { Authorization: `Basic ${attachmentToken}` },
        },
      );
      const ext = response.data?.FileExtension || "bin";
      const blob = base64ToBlob(response.data?.FileContentBase64, ext);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${response.data?.FileName || systemId}.${ext}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      reportAttachmentError(error, "Failed to download the attachment.");
    }
  };

  const handleSelectedFiles = (e) => {
    const files = e.target.files;
    setNewSelectedFile(Array.from(files));
  };

  return (
    <>
      {/* <h2
        style={{
          paddingTop: "10px",
          paddingBottom: "10px",
          paddingLeft: "20px",
          background: "white",
        }}
      >
        {title}
      </h2> */}
      {/* Actions */}
      <div
        style={{
          padding: "20px",
          paddingBottom: "20px",
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          backgroundColor: "white",
        }}
      >
        <button
          type="button"
          onClick={() => navigate(`/${redirectTo}`)}
          style={styles.button}
        >
          Back
        </button>
        {actions.map((action, i) => (
          <button
            key={i}
            type="button"
            onClick={action.fx}
            style={{
              ...styles.button,
              display: action.visible === false ? "none" : "inline-flex",
              backgroundColor: action.color || "none",
            }}
          >
            {action.icon && (
              <span style={{ marginRight: "6px" }}>{action.icon}</span>
            )}
            {action.name}
          </button>
        ))}
      </div>
      <div className="form-layout">
        {/* Form Fields */}
        <form
          className="form-grid"
          onSubmit={(e) => e.preventDefault()}
          style={{ backgroundColor: "white" }}
        >
          {fields.map((field) => (
            <div key={field.name} className="form-field">
              <label style={styles.label}>{field.label}</label>
              {renderField(field)}
            </div>
          ))}
        </form>
        {/* Attachments */}
        <div className="card-attachments">
          <Row>
            <Col md={6} sm={12}>
              <label style={styles.label}>Attachments</label>
              <input
                type="file"
                multiple
                onChange={(e) => handleSelectedFiles(e)}
                ref={fileInputRef}
                disabled={!canAttach}
              />
            </Col>

            {tableId !== 0 && (
              <Col md={2} sm={12}>
                <button
                  style={{ ...styles.button, marginTop: "5px" }}
                  onClick={(e) => {
                    e.preventDefault();
                    makeAttachment(
                      newSelectedFile[0],
                      documentNo,
                      initialData.documentType,
                    );
                  }}
                  disabled={!canAttach || isAttaching || newSelectedFile.length === 0}
                >
                  {isAttaching ? "Attaching..." : "Attach"}
                </button>
              </Col>
            )}
          </Row>
          {selectedFile.length > 0 || newSelectedFile.length > 0 ? (
            <table className="attachment-table">
              <thead>
                <tr>
                  <th>File Name</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {newSelectedFile.map((a, k) => (
                  <tr key={k}>
                    <td>{a.name}</td>
                    <td></td>
                  </tr>
                ))}
                {selectedFile.map((a, k) => (
                  <tr key={k} className="py-1">
                    <td>
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          downloadAttachment(a.SystemId || a.systemId || a.id);
                        }}
                      >
                        {a.FileName || a.fileName}
                      </Link>
                    </td>
                    <td>
                      <Link
                        to="#10"
                        style={{ color: "#a45263ff" }}
                        onClick={(e) => {
                          e.preventDefault();
                          removeAttachment(a.SystemId || a.systemId, documentNo);
                        }}
                      >
                        Remove
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div
              style={{ marginTop: "10px", fontStyle: "italic", color: "#666" }}
            >
              No attachments available.
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const styles = {
  label: { display: "block", fontWeight: "bold", marginBottom: "4px" },
  input: {
    width: "100%",
    padding: "6px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  button: {
    padding: "8px 14px",
    border: "1.25px solid maroon",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default StandardPageMain;
